import { useApolloClient } from "@apollo/client";
import Grid from "@mui/material/Grid";
import React, { useEffect, useMemo, useState } from "react";
import { Location, ToggleButtonComponent } from "../../../components";
import {
  GETCOMPANYDETAILS,
  GETLEADBYOWNERDROPDOWN,
} from "../../../graphql/quotationQueries";
import { enumSelect, enum_types, LocalStorageKeys } from "../../../utils";
import { loadOptionsApis, loadOptions as loadOptionsQuery } from "../../../utils/asyncPaginateLoadOptions";
import {
  CustomAsyncSelect,
  CustomDatePicker,
  LeadSelect,
  LocationTextField,
  RequiredArea,
} from "../components";
import { Purpose, SearchIcon, UnitCategory } from "../components/svg";
import {
  getDateValue,
  loadOptions,
  measurementUnits,
  returnMomentFormat,
} from "../utils";

export const Commercial = (props) => {
  const {
    data = {},
    filterData = {},
    onChangeState,
    location,
    handleLead,
    selectedLead,
    t,
    getCurrentLocation,
        purpose
  } = props;

  const [loading, setLoading] = useState(null);
  const client = useApolloClient();
  const [enumValue, setEnum] = React.useState({
    purpose: [],
  });
  const current_date = new Date();
  const moduleId = localStorage.getItem(LocalStorageKeys.activeRoleModuleId);
  const is_workspace = ['49', '35'].includes(moduleId)
  let min_date_duration = current_date.setFullYear(
    current_date.getFullYear() - 1
  );
  const [propertyPurpose, setPropertyPurpose] = useState("Lease");

  useEffect(() => {
    if (data?.propertyPurpose) {
      setPropertyPurpose(data.propertyPurpose);
    }
  }, [data]);

  const getCompnayDetails = () => {
    client
      .query({
        query: GETCOMPANYDETAILS,
        fetchPolicy: "network-only",
        variables: {
          id: props?.company,
        },
      })
      .then((res) => {
        onChangeState("requiredArea", {
          maxArea: "10000",
          minArea: "1",
          measurement:
            is_workspace
              ? 9
              : res?.data?.company_master[0]?.uom_master?.value,
          mesurmentLabel:
            is_workspace
              ? "Seat"
              : res?.data?.company_master[0]?.uom_master?.label,
        });
      })
      .catch((err) => console.log(err));
  };
  React.useEffect(() => {
    if (props?.company) {
      getCompnayDetails();
    }
    // eslint-disable-next-line
  }, [props?.company]);
  const handleLoadOptions = (search, array, type, functionParams) => {
    setLoading(type);
    return loadOptions(
      search,
      array,
      type,
      {
        revenue: props?.type ?? "Commercial",
        ...functionParams,
      },
      setLoading,
      props?.company
    );
  };

  const getDateOutput = useMemo(() => {
    return getDateValue(data?.duration, false, filterData?.facilitesbool);
  }, [data?.duration, filterData?.facilitesbool]);

  const returnRequiredArea = useMemo(() => {
    const {
      maxArea = "",
      minArea = "",
      mesurmentLabel = "",
    } = data?.requiredArea ?? {};
    return minArea && maxArea
      ? `${minArea} - ${maxArea} ${mesurmentLabel}`
      : "";
  }, [data?.requiredArea]);

  const getEnum = async () => {
    const result = await enumSelect([enum_types.revenue_type]);
    setEnum({
      purpose: result?.revenue_type,
    });
  };
  useEffect(() => {
    getEnum();
    // eslint-disable-next-line
  }, []);

  const manualResponse = (array) =>
    array?.map((_) => {
      return {
        ..._,
        label: _?.contact?.first_name,
        value: _?.contact?.id,
      };
    });
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} sm={6} lg={4}>
          <LeadSelect
            label={t("Search Opportunities")}
            placeholder={t("Search")}
            icon={<SearchIcon width={12} height={12} />}
            value={selectedLead ?? null}
            onChange={(value) => handleLead(value)}
            isPaginate
            loadOptions={(search, array, handleLoading) =>
              loadOptionsQuery(
                search,
                array,
                handleLoading,
                GETLEADBYOWNERDROPDOWN,
                "lead",
                {
                  company: props?.company,
                  client: localStorage.getItem(LocalStorageKeys.clinetID),
                },
                {},
                {},
                manualResponse
              )
            }
            debounceTimeout={800}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={is_workspace ? 9 : 6}
          md={is_workspace ? 9 : 6}
          lg={4}
        >
          <Location
            value={location}
            handleChange={(value) => onChangeState("location", value)}
            textFieldComponent={(ref, value, handleChange) => (
              <LocationTextField
                label={t("Location")}
                inputRef={ref}
                handleChange={handleChange}
                value={value}
                placeholder={t("Select City")}
                getCurrentLocation={getCurrentLocation}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} md={6} sm={6} lg={4}>
          {data?.propertyPurpose === "Sale" ? (
            <CustomDatePicker
              placeholder={t("Choose Handover Date")}
              label={t("Handover")}
              value={data?.handOverDate}
              data={
                data?.handOverDate?.date
                  ? returnMomentFormat(data?.handOverDate?.date)
                  : ""
              }
              onChange={(value) => onChangeState("handOverDate", value)}
              title={t("Handover Date")}
              min_date_duration={min_date_duration}
            />
          ) : (
            <CustomDatePicker
              placeholder={t("Choose Date Range")}
              label={t("Duration")}
              value={data?.duration}
              data={getDateOutput}
              onChange={(value) => onChangeState("duration", value)}
              title={t("Lease Duration")}
              showEndDate
              min_date_duration={min_date_duration}
            />
          )}
        </Grid>
        {!is_workspace && (
          <Grid item xs={3} md={3}>
            <ToggleButtonComponent
              options={[
                { label: "Lease", value: "Lease" },
                { label: "Sale", value: "Sale" },
              ]}
              value={propertyPurpose}
              onChange={(value) => {
                setPropertyPurpose(value);
                onChangeState("propertyPurpose", value);
              }}
              height="62px"
              buttonGroupStyle={{
                gap: "6px",
                marginTop: "0px",
              }}
              buttonStyle={{
                width: "48%",
                border: "1px solid transparent",
                "&&:hover": {
                  // Increase the specificity of the &:hover selector
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #5078E1", // Change the border color to blue
                  color: "#5078E1",
                },
                "&.Mui-selected": {
                  "&:hover": {
                    backgroundColor: "#5078E1",
                    border: "1px solid #5078E1",
                    color: "#FFFFFF",
                  },
                },
              }}
            />
          </Grid>
        )}

        <Grid item xs={3} md={3}>
          <CustomAsyncSelect
            placeholder={t("Select Type")}
            value={data?.propertyType ?? null}
            onChange={(value) => onChangeState("propertyType", value)}
            label={t("Property Type")}
            icon={<Purpose width={15} height={15} />}
            loading={loading === "property_group_master"}
            isPaginate
            debounceTimeout={800}
            loadOptions={(search, array) =>
              handleLoadOptions(search, array, "property_group_master", {
                all: true,
              })
            }
          />
        </Grid>

                <Grid item xs={3} md={3}>
                    <CustomAsyncSelect
                        placeholder={t("Select Category")}
                        // options={UNITCATEGORYLIST(props?.type ? 'storage' : 'commercial')}
                        value={data?.unitCategory ?? null}
                        onChange={value => onChangeState('unitCategory', value)}
                        label={t("Unit Category")}
                        icon={<UnitCategory width={15} height={15} />}
                        loading={loading === "unit_category_master"}
                        isPaginate={true}
                        // loadOptions={(search, array, handleLoading) => loadOptionsQuery(
                        //     search,
                        //     array,
                        //     handleLoading,
                        //     GET_UNIT_CATEGORY_LEASE,
                        //     'unit_category_master',
                        //     { all: true,ids:moduleId==="35"?[7,8,9,3]:[] }
                        // )}
                        loadOptions={(search, array, handleLoading)=> 
                            loadOptionsApis(
                                "queries/unit_category/get",
                                { type:!is_workspace ? "property_search" : "property_search_workspace" , purpose:purpose },
                                search,
                                array,
                                handleLoading,
                              "unit_category_master",
                              null,
                              null,
                                {all:true}
                            )
                        }
                    />
                </Grid>
                <Grid item xs={3} md={3}>
                    <RequiredArea
                        label={t("Required Area")}
                        // disabled={data?.unitCategory?.value === unitCategoryEnum?.plot || data?.unitCategory?.value === unitCategoryEnum?.land ? false : true}
                        data={data?.requiredArea}
                        onChange={value => onChangeState('requiredArea', value)}
                        options={measurementUnits}
                        value={returnRequiredArea}
                    />
                </Grid>
            </Grid >
        </div >
    )
}
